export default __webpack_public_path__ + "static/food-d723f7a13999b3ce151b04c221f857c1.webp";